export function AsanaIcon({ className }: { className?: string }) {
    return (
      <svg 
        className={className} 
        width="39" 
        height="36" 
        viewBox="0 0 39 36" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        <path 
          d="M30.5184 19.0587C25.8336 19.0587 22.0364 22.8509 22.0364 27.529C22.0364 32.2075 25.8336 36 30.5184 36C35.2026 36 39 32.2075 39 27.529C39 22.8509 35.2026 19.0587 30.5184 19.0587ZM8.48178 19.0593C3.79756 19.0593 0 22.8509 0 27.5295C0 32.2075 3.79756 36 8.48178 36C13.1663 36 16.964 32.2075 16.964 27.5295C16.964 22.8509 13.1663 19.0593 8.48178 19.0593ZM27.9816 8.47036C27.9816 13.1485 24.1844 16.9416 19.5002 16.9416C14.8156 16.9416 11.0183 13.1485 11.0183 8.47036C11.0183 3.79251 14.8156 0 19.5002 0C24.1844 0 27.9816 3.79251 27.9816 8.47036Z" 
          fill="url(#paint0_radial_asana)" 
        />
        <defs>
          <radialGradient 
            id="paint0_radial_asana" 
            cx="0" 
            cy="0" 
            r="1" 
            gradientUnits="userSpaceOnUse" 
            gradientTransform="translate(1950 1967.48) scale(2584.27 2385.48)"
          >
            <stop stopColor="#FFB900"/>
            <stop offset="0.6" stopColor="#F95D8F"/>
            <stop offset="0.9991" stopColor="#F95353"/>
          </radialGradient>
        </defs>
      </svg>
    )
  }